// extracted by css-extract-rspack-plugin
export default {"dropdown":"gxVxDEYmV4USEIi9","results":"IjNVUj1LiV4hcALQ","actions":"Zt031ujAsxY0HNit","viewAllResults":"AI9YJrV9EdcTgesr"};